<script setup lang="ts">
import { useRoute } from 'vue-router';

import { useRouterBack } from '@/core/router-back';

import ClientOnly from './client-only';

const route = useRoute();

function onLeave(_: unknown, done: () => void) {
  if (props.leaveDuration) setTimeout(done, props.leaveDuration);
  else done();
}

const props = defineProps<{ name: string; leaveDuration?: number }>();

const routerBack = useRouterBack();
</script>

<template>
  <ClientOnly>
    <Transition :css="false" @leave="onLeave">
      <slot
        v-if="route.query[props.name] !== undefined"
        :back="
          async () =>
            await routerBack({
              query: { ...route.query, [props.name]: undefined },
            })
        "
      ></slot>
    </Transition>
  </ClientOnly>
</template>
